import possibleTypes from '@src/Api/Graphql/gql/introspection-result.generated';


export type AllPossibleTypes =
  {
    [K in keyof typeof possibleTypes.possibleTypes]:
      (typeof possibleTypes)['possibleTypes'][K][number]
  }[keyof typeof possibleTypes.possibleTypes];

export const ContentTypes = Object.fromEntries(
  (possibleTypes.possibleTypes.Content as string[]).map(type => [type, type]),
) as Record<AllPossibleTypes, AllPossibleTypes>;

type WithTypeName = {__typename?: string};

/**
 * Utilitaire centralisant les fonctions de vérification de type pour les objets Umbraco Content.
 *
 * Fournit des helpers pour vérifier dynamiquement le type d'un objet GraphQL (via __typename),
 * avec autocomplétion et sécurité de type grâce à AllPossibleTypes.
 *
 * Usage :
 *   UmbTypeChecker.isType(obj, 'Course') // check générique
 *   UmbTypeChecker.isPaywall(obj)        // helper spécifique pour le type Paywall
 */
export class UmbTypeChecker {
  static isType<T extends AllPossibleTypes>(
    obj: WithTypeName | undefined,
    type: T,
  ): obj is {__typename: T} {
    return obj?.__typename === type;
  }

  /**
   * Retourne l'objet casté au bon type si le type correspond, sinon undefined.
   */
  static asType<T extends AllPossibleTypes, O extends WithTypeName>(
    obj: O | undefined,
    type: T,
  ): (O & {__typename: T}) | undefined {
    return UmbTypeChecker.isType(obj, type) ? (obj as O & {__typename: T}) : undefined;
  }
  
  static isPaywall = (
    obj: WithTypeName | undefined,
  ): obj is {__typename: 'Paywall'} =>
    UmbTypeChecker.isType(obj, ContentTypes.Paywall);
}
